import { registerFeatureWithDescription } from "lib/features"
import { isEnabled } from "lib/@components/feature"
import { ScheduleDetail, TaskRowAfterEntry } from "slot-definitions"
import { FEATURE_FLAG_CLIENT_SCHEDULE_FIELDS } from "./server/feature-flag-client-schedule-fields.mjs"
import { ClientScheduleFields } from "./client-schedule-fields"
import { TaskReferenceCode } from "./task-reference-code"
import "./client-schedule-fields-comparitor"

// Registration lives here (not a feature-flag-*.js) because the numerical-id
// uniqueness guard only scans .runtime.js files
registerFeatureWithDescription({
    numericalId: 409,
    id: FEATURE_FLAG_CLIENT_SCHEDULE_FIELDS,
    name: "Client Schedule Fields",
    internalUseOnly: true,
    descriptionLines: [
        "Adds a free-text custom field and a reference tag to client custom schedules.",
        "Shows a derived read-only task reference code (SCH + tag + frequency, e.g. SCHELERCD01Y) on each task.",
        "Surfaces all three as columns in the regime share-link Excel export.",
    ],
})

ScheduleDetail.plug(<ClientScheduleFields $lazy priority={150} if={showsClientScheduleFields} />)
// Own full-width row directly beneath the task meta row (inside the accordion title)
TaskRowAfterEntry.plug(<TaskReferenceCode $lazy priority={50} if={showsClientScheduleFields} />)

function showsClientScheduleFields(context) {
    // context.schedule, not context.target: inside task rows the nested Bound makes
    // target the task, while schedule is inherited from the editor's outer context.
    // Excluded from PDF rendering: printed schedules are out of scope for FIQ-1570.
    return (
        !context.isPDF && isEnabled(FEATURE_FLAG_CLIENT_SCHEDULE_FIELDS) && Number(context.schedule?.ScheduleType) === 2
    )
}
